export default __webpack_public_path__ + "static/airbnb-2-1a23a974184d8fac7b65fb65436f26c8.png";